import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class QuoteTemplate extends BaseBus
{
    constructor(busObj: QuoteTemplate = null) {
        super(busObj);
        this.InsertDt = DateFunctions.getDate(this.InsertDt);
        this.UpdateDt = DateFunctions.getDate(this.UpdateDt);
    }
    CID(): any {
        return this.QuoteTemplateId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.InsertDt)) {
            this.InsertDt = date;
            this.InsertUserId = userId;
        }
        this.UpdateDt = date;
        this.UpdateUserId = userId;
    }
    setParentId(id: any) {
        this.QuoteTemplateId = id;
    }

    QuoteTemplateId: any;
    QuoteId: any;
    QuoteTemplateName: string;
    Customer: string;
    Location: string;
    IsActive: boolean;
    IsGlobal: boolean;
    IsSalesPackage: boolean;
    UserId: any;
    CompanyId: any;
    InsertUserId: any;
    InsertDt: Date;
    UpdateUserId: any;
    UpdateDt: Date;
}
